module.exports = __webpack_public_path__ + "static/figurine_of_wondrous_power_ivory_goats-4fd40613dcff9969c915465a47251e6f.jpg";